import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { BLOCK_MODULE_NAMESPACE, BLOCK_GET_BLOCK, BLOCK_SET_LOADER_STATE, BLOCK_LOADERS } from '../../../store/block';
import { IBlockListingViewModel } from '../../../models/block';
import { IApartmentParameter, IApartmentListingViewModel } from '../../../models/apartment';
import { APARTMENT_MODULE_NAMESPACE, APARTMENT_GET_APPARTMENTS, APARTMENT_RESET_APPARTMENTS } from '../../../store/apartment';
import { ActivityStatus } from '../../../common/enums';
import { IPagination } from '../../../models/generic';
import {AUTHORIZATION_FUNCTIONALITIES, AUTHORIZATION_MODULE_NAMESPACE} from '../../../store/authorization';
const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE)

const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)
const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE)
@Component({
  components: {
    'block-condition': async () => import('../components/block-conditions/BlockConditions.vue'),
    'block-grid-item': async () => import('../components/block-apartment-item/BlockApartmentItem.vue'),
    'grid-loader': async () => import('../loaders/block-list-loader/BlockListLoader.vue')
  }
})
class BlockApartmentsDetail extends Vue {
  dtStyle: any;
  dtPreviousWidth: number = window.innerWidth;
  dtNeedMerge: boolean;
  _clearTimeout: any;
  /**
   * Store declarations
   */

  @BlockStore.Getter currentBlock: IBlockListingViewModel;
  @ApartmentStore.Getter apartments: IApartmentListingViewModel[];
  @ApartmentStore.Getter apartmentParameter: IApartmentParameter;
  @ApartmentStore.Getter activityStatus: ActivityStatus;
  @ApartmentStore.Getter pagination: IPagination;

  @BlockStore.Action(BLOCK_GET_BLOCK)
  storeGetBlockById: (blockId: string) => Promise<IBlockListingViewModel>;

  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS)
  storeGetApartmentByBlockId: (payload: { param: IApartmentParameter, blockId: string }) => Promise<IApartmentListingViewModel[]>;

  @AuthorizationStore.Action(AUTHORIZATION_FUNCTIONALITIES)
  storeGetFunctionalities: (moduleName: string) => Promise<any>;

  @BlockStore.Mutation(BLOCK_SET_LOADER_STATE)
  storeSetLoaderState: (payload?: { key: string, value: boolean }) => void

  @ApartmentStore.Mutation(APARTMENT_RESET_APPARTMENTS)
  storeResetApartments: () => void;
  /**
   *
   */
  constructor() {
    super();
    this.dtStyle = null;
    this.dtNeedMerge = false;
  }
  get isLoading(): boolean {
    return this.activityStatus === ActivityStatus.Loading;
  }
  get blockId(): string {
    return this.$route.params.id;
  }
  get coSearchParameter() {
    return {
      param: this.apartmentParameter,
      merge: this.dtNeedMerge,
      blockId: this.blockId
    }
  }
  get coCurrentBlock() {
    return this.currentBlock;
  }
  initMapContainer() {
    let intervalMapTracer: any;
    let isCleared: boolean;
    let mapboxRef: any;
    this.$nextTick(() => {
      isCleared = false;
      if (!isCleared) {
        intervalMapTracer = setInterval(() => {
          mapboxRef = this.$refs.apartmentRef
          if (mapboxRef) {
            clearInterval(intervalMapTracer);
            let mainContainer = document.getElementsByClassName('main-container')[0];
            if (mainContainer) {
              let width: number = (mainContainer.clientWidth - 400) / 4;
              if (width > 280) width = 280;
              this.dtStyle = {
                width: width + 'px !important',
                'min-width': width + 'px !important',
                'max-width': width + 'px !important',
                height: width + 'px  !important',
                'min-height': width + 'px  !important',
                'max-height': width + 'px  !important'
              }

            }

          }
        }, 300)
      }

    })
  }
  mounted () {
    this.storeGetBlockById(this.blockId)
      .catch(response => console.log(response))
    this.initMapContainer()
    if (this.$route.path.indexOf('apartment') > -1) {
      window.onresize = () => this.initMapContainer()
    }
  }

  setListLoaderState(value: boolean){
    this.storeSetLoaderState({ key: BLOCK_LOADERS.LIST, value })
  }
}

export default BlockApartmentsDetail;



// WEBPACK FOOTER //
// ./src/containers/block/block-apartments-grid/index.ts